import { Input } from '@/components/ui/input'
import { useContext, useLayoutEffect, useState } from 'react'
import { FormContext } from '../FormProvider'
import { FormFieldProps, FormNumberType } from './type'

export const FormNumberField = ({
  data,
  field,
}: FormFieldProps<FormNumberType>) => {
  const context = useContext(FormContext)
  const [displayValue, setDisplayValue] = useState('')

  // 숫자를 콤마가 포함된 문자열로 변환
  const formatNumber = (num: number | undefined) => {
    if (num === undefined || num === null) return ''
    return num.toLocaleString()
  }

  // 콤마가 포함된 문자열에서 숫자만 추출
  const parseNumber = (str: string) => {
    const cleanStr = str.replace(/,/g, '')
    return cleanStr === '' ? undefined : Number(cleanStr)
  }

  useLayoutEffect(() => {
    if (typeof data.default === 'number') {
      context.formProps.form?.setValue(data.key, data.default)
      setDisplayValue(formatNumber(data.default))
    }
  }, [])

  useLayoutEffect(() => {
    setDisplayValue(formatNumber(field.value))
  }, [field.value])

  return (
    <Input
      value={displayValue}
      disabled={data.readOnly}
      className="disabled:!border-0 disabled:opacity-75"
      placeholder={data.placeholder?.toString() || data.label}
      onWheel={(e) => {
        // 스크롤로 숫자 변경 방지
        e.currentTarget.blur()
      }}
      onKeyDown={(e) => {
        // 숫자, Backspace, Delete, Arrow keys만 허용
        const allowedKeys = [
          'Backspace',
          'Delete',
          'ArrowLeft',
          'ArrowRight',
          'Tab',
        ]
        if (!allowedKeys.includes(e.key) && !/^\d$/.test(e.key)) {
          e.preventDefault()
        }
      }}
      onChange={(e) => {
        const inputValue = e.target.value

        if (!inputValue || inputValue === '') {
          setDisplayValue('')
          field.onChange(undefined)
          return
        }

        // 숫자와 콤마만 허용
        const cleanValue = inputValue.replace(/[^\d,]/g, '')
        const numericValue = parseNumber(cleanValue)

        if (numericValue !== undefined && !isNaN(numericValue)) {
          const formattedValue = formatNumber(numericValue)
          setDisplayValue(formattedValue)
          field.onChange(numericValue)
        }
      }}
    />
  )
}
